import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PermissionsGuard } from './guards/permissions.guard';

// Components
import { JurorRegistrationComponent } from "./components/juror-registration/juror-registration.component";
import { AppComponent } from "./app.component";
import { TokenConfirmationComponent } from "./components/token-confirmation/token-confirmation.component";
import { TokenConfirmedComponent } from "./components/token-confirmed/token-confirmed.component";
import { RegistrationSubmittedComponent } from "./components/registration-submitted/registration-submitted.component";
import { HomePageComponent } from "./components/home-page/home-page.component";
import { UserRegistrationComponent } from "./components/user-registration/user-registration.component";
import { RecordCompanyRegistrationComponent } from "./components/record-company-registration/record-company-registration.component";
import { ErrorComponent } from "./components/error/error.component";
import { RecordCompanyRLRegistrationComponent } from "./components/record-company-rl-registration/record-company-rl-registration.component";

const routes: Routes = [
  {
    path: "user-registration",
    data: {
      breadcrumb: "User Registration",
      permissions: ['ExternalUserRegistration']
    },
    component: UserRegistrationComponent,
    canActivate : [PermissionsGuard]
  },
  {
    path: "record-company-user-registration",
    component: RecordCompanyRLRegistrationComponent,
    data: {
      breadcrumb: "New Registration",
       permissions: ['RecordCompanyUserRegistration']
    },
     canActivate : [PermissionsGuard]
  },
  {
    path: "record-company-registration",
    component: RecordCompanyRegistrationComponent,
    data: {
      breadcrumb: "Record Company Registration",
      permissions: ['RecordCompanyRegistration']
    },
    canActivate : [PermissionsGuard]
  },
  {
    path: "juror-registration",
    component: JurorRegistrationComponent,
    data: {
      breadcrumb: "Jury Registration",
      permissions: ['JurorRegistration']
    },
     canActivate : [PermissionsGuard]
  },
  {
    path : "new-registration/registration-submitted/:token",
    component : RegistrationSubmittedComponent,
    data : {
      breadcrumb: "Registration submitted"
    },
  },
  {
    path: "token-confirmation/:userId",
    component: TokenConfirmationComponent,
    data: {
      breadcrumb: "Confirm Token Code",
      permissions: ['CheckToken'],
    },
    canActivate : [PermissionsGuard]
  },
  {
    path: "token-confirmed",
    component: TokenConfirmedComponent,
    data: {
      breadcrumb: "Confirm Token Code"
    }
  },
  {
    path: "home-page",
    component: HomePageComponent,
    data: {
      breadcrumb: "Home Page"
    }
  },
  {
		path: 'error/:type',
		data: {
			breadcrumb: 'Error'
		},
		component: ErrorComponent
	},
  {
    path: "",
    redirectTo: "home-page",
    pathMatch: "full"
  },
  {
    path: "**",
    redirectTo: "home-page",
    pathMatch: "full"
  }
];

@NgModule({
	imports: [
    RouterModule.forRoot(routes, {useHash: true})
	],
	exports: [
		RouterModule
	]
})

export class AppRoutingModule {
}
